import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import {
  ApDevice,
} from 'src/app/shared/model/ap';
import { BaseLicensesTypes } from 'src/app/shared/model/template';
import { UserConstant } from 'src/app/shared/constants/user-constant';
import { ApService } from 'src/app/shared/services/ap.service';
import { TopnavbarService } from 'src/app/shared/services/topnavbar.service';
import { UserService } from 'src/app/shared/services/user.service';

interface DeviceReportColumn {
  id: string;
  label: string;
  path: string;
  selected?: boolean;
}

interface ReportOrgOption {
  orgId: string;
  name: string;
  role: number;
  parentOrg?: string;
}

interface DeviceListReportRequest {
  orgId: string;
  limit?: number;
  registration?: 'all' | 'registered' | 'pending';
  filters?: { mode: 'all' | 'any'; rules: DeviceReportFilter[] };
  devices?: Array<{
    mac?: string;
    name?: string;
  }>;
  columns: Array<{
    id: string;
    label: string;
    path: string;
  }>;
}

interface DeviceReportFilter {
  path: string;
  operator: 'eq' | 'ne' | 'contains' | 'startsWith' | 'isNull' | 'isEmpty';
  value: string | number | boolean;
}

@Component({
  selector: 'app-device-list-report',
  templateUrl: './device-list-report.component.html',
  styleUrls: ['./device-list-report.component.scss']
})
export class DeviceListReportComponent implements OnInit, OnDestroy {
  registration: 'all' | 'registered' | 'pending' = 'all';
  customFilters: DeviceReportFilter[] = [];
  filterMode: 'all' | 'any' = 'all';
  filterFieldSearch = '';
  customFilterPath = '';
  filterError = '';
  private draggedFilterIndex: number = null;
  private draggedFilterPath = '';
  private generationSubscription: Subscription;
  loading = false;
  orgId: any;
  org: any;
  user: any;
  currentRole: number;

  deviceArray: ApDevice[] = [];
  filteredDeviceArray: ApDevice[] = [];
  allOrgList: ReportOrgOption[] = [];
  mmspList: ReportOrgOption[] = [];
  filteredMmspList: ReportOrgOption[] = [];
  mspList: ReportOrgOption[] = [];
  filteredMspList: ReportOrgOption[] = [];
  orgList: ReportOrgOption[] = [];
  filteredOrgList: ReportOrgOption[] = [];
  selectedMmsp = 'All';
  selectedMsp = 'All';
  selectedOrg = 'All';
  mmspSearchText = '';
  mspSearchText = '';
  orgSearchText = '';
  availableColumnSearch = '';
  selectedColumnSearch = '';
  availableColumns: DeviceReportColumn[] = [
    { id: 'name', label: 'Host Name', path: 'name' },
    { id: 'mac', label: 'Mac Address', path: 'mac' },
    { id: 'msp', label: 'MSP', path: 'msp' },
    { id: 'domain', label: 'Domain', path: 'domain' },
    { id: 'organization', label: 'Organization', path: 'organization' },
    { id: 'location', label: 'Location', path: 'location' },
    { id: 'country', label: 'Country', path: 'country' },
    { id: 'state', label: 'State', path: 'state' },
    { id: 'city', label: 'City', path: 'city' },
    { id: 'model', label: 'Model', path: 'model' },
    { id: 'device_model', label: 'Model', path: 'deviceMetaInfo.deviceModel' },
    { id: 'device_type', label: 'Device Type', path: 'deviceMetaInfo.deviceType' },
    { id: 'serial_number', label: 'Serial Number', path: 'serialNumber' },
    { id: 'firmware', label: 'Firmware', path: 'firmware' },
    { id: 'current_firmware', label: 'Firmware', path: 'statistics.firmware.currentVersion' },
    { id: 'machine_id', label: 'Machine ID', path: 'machineId' },
    { id: 'uptime', label: 'Uptime', path: 'upTime' },
    { id: 'status', label: 'Status', path: 'status' },
    { id: 'pending', label: 'Pending', path: 'pending' },
    { id: 'org_id', label: 'Organization ID', path: 'orgId' },
    { id: 'base_license', label: 'License', path: 'baseLicense' },
    { id: 'addon_license', label: 'Add-on License', path: 'addOnLicense' },
    { id: 'prtg_id', label: 'PRTG ID', path: 'prtgId' },
    { id: 'prtg_sensor_id', label: 'PRTG Sensor ID', path: 'prtgSensorId' },
    { id: 'wnetwork', label: 'WiFi Network Template', path: 'wnetwork' },
    { id: 'qos', label: 'QoS Template', path: 'qos' },
    { id: 'glte_template', label: '4GLTE Template', path: '4glte' },
    { id: 'team', label: 'Team Template', path: 'team' },
    { id: 'tprofile', label: 'Template Profile', path: 'tprofile' },
    { id: 'revision_id', label: 'Revision ID', path: 'revisionId' },
    { id: 'port', label: 'Port', path: 'port' },
    { id: 'last_seen', label: 'Last Seen', path: 'lastSeen' },
    { id: 'terminal_jump', label: 'Terminal Jump', path: 'terminal_url' },
    { id: 'order_date', label: 'Order Date', path: 'orderdate' },
    { id: 'activated_at', label: 'Activated Date', path: 'activatedAt' },
    { id: 'reset403_at', label: 'Reset 403 Date', path: 'reset403At' },
    { id: 'created_at', label: 'Install Date', path: 'createdAt' },
    { id: 'address', label: 'Provisioned Address', path: 'provisionedConfig.address' },
    { id: 'gateway_ip', label: 'Gateway IP', path: 'provisionedConfig.gatewayIp' },
    { id: 'netmask', label: 'Netmask', path: 'provisionedConfig.netmask' },
    { id: 'name_server', label: 'Name Server', path: 'provisionedConfig.nameServer' },
    { id: 'statistics_status', label: 'Status Type', path: 'statistics.statusType' },
    { id: 'statistics_mac', label: 'Statistics MAC', path: 'statistics.mac' },
    { id: 'statistics_machine_id', label: 'Statistics Machine ID', path: 'statistics.machineId' },
    { id: 'cpu_count', label: 'CPU Count', path: 'statistics.cpuCount' },
    { id: 'nic_count', label: 'NIC Count', path: 'statistics.nicCount' },
    { id: 'arch', label: 'Architecture', path: 'statistics.arch' },
    { id: 'connection_count', label: 'Connection Count', path: 'statistics.connection_count' },
    { id: 'connection_max', label: 'Connection Max', path: 'statistics.connection_max' },
    { id: 'timezone', label: 'Timezone', path: 'statistics.timezone' },
    { id: 'glte_ip', label: '4GLTE IP', path: 'statistics.4glte.ip' },
    { id: 'glte_operator', label: '4GLTE Operator', path: 'statistics.4glte.operator' },
    { id: 'glte_sim_status', label: '4GLTE SIM Status', path: 'statistics.4glte.sim_status' },
    { id: 'glte_data_status', label: '4GLTE Data Status', path: 'statistics.4glte.data_status' },
    { id: 'lan_mac', label: 'LAN MAC', path: 'statistics.vlan_info.lan_mac' },
    { id: 'wan_mac', label: 'WAN MAC', path: 'statistics.vlan_info.wan_mac' },
    { id: 'wan2_mac', label: 'WAN2 MAC', path: 'statistics.vlan_info.wan2_mac' }
  ];
  selectedColumns: DeviceReportColumn[] = [];
  generatedColumns: DeviceReportColumn[] = [];
  generatedColumnIds: string[] = [];
  generatedRows: any[] = [];
  tableGenerated = false;
  canExportCsv = false;
  sampleRequest: DeviceListReportRequest = null;
  generateLoading = false;
  generateError = '';
  csvImportError = '';
  csvImportFileName = '';
  importedDevices: Array<{ mac?: string, name?: string }> = [];
  generateResponse: any = null;
  totalDeviceCount = 0;
  private readonly defaultSelectedColumnIds = [
    'name',
    'mac',
    'msp',
    'domain',
    'organization',
    'location',
    'device_model',
    'current_firmware',
    'base_license',
    'created_at',
    'last_seen',
    'status'
  ];

  private routeSubscription: Subscription;
  private loadDataSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private apService: ApService,
    private userService: UserService,
    private topnavbarService: TopnavbarService
  ) { }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem(UserConstant.USER));
    this.currentRole = Number(this.user.role);
    this.setDefaultSelectedColumns();
    this.loadOrganizationFilters();

    this.routeSubscription = this.route.paramMap.subscribe(params => {
      const routeId = params.get('id');
      this.orgId = this.getRouteOrgId(routeId);
      this.setTopNavMenu();
    });
  }

  getRouteOrgId(routeId: string) {
    const id = routeId ? routeId.split('_').pop() : this.user.organization;
    return this.userService.normalizeOrganizationId(id);
  }

  loadOrganizationFilters() {
    const rootOrgId = this.userService.normalizeOrganizationId(this.user.organization);
    this.userService.getOrganizationUsers({ id: rootOrgId }).subscribe(results => {
      const rootOrg = results && results.data ? results.data[0] : null;
      if (!rootOrg) return;

      this.allOrgList = this.getDomainOrgs(rootOrg);
      this.applyDeviceOrganizationLabels();

      if (this.currentRole === 0) {
        this.setMmspList(this.withAllOption(this.allOrgList.filter(org => org.role === 1)));
        this.setMspList([]);
        this.setOrgList([]);
      } else if (this.currentRole === 1) {
        this.selectedMmsp = rootOrgId;
        this.setMspList(this.withAllOption(this.allOrgList.filter(org => org.parentOrg === rootOrgId && org.role === 2)));
        this.setOrgList([]);
      } else if (this.currentRole === 2) {
        this.selectedMsp = rootOrgId;
        this.setMspList(this.allOrgList.filter(org => org.orgId === rootOrgId));
        this.setOrgList(this.withAllOption(this.allOrgList.filter(org => org.parentOrg === rootOrgId && org.role === 3)));
      } else {
        this.selectedOrg = rootOrgId;
        this.setOrgList(this.allOrgList.filter(org => org.orgId === rootOrgId));
      }
    });
  }

  getDomainOrgs(domain): ReportOrgOption[] {
    if (!domain) return [];

    let filteredOrg: ReportOrgOption[] = [{
      orgId: this.userService.normalizeOrganizationId(domain._id),
      name: domain.name,
      role: Number(domain.role),
      parentOrg: this.userService.normalizeOrganizationId(domain.parentOrganization)
    }];

    (domain.subOrganizations || []).forEach(org => {
      filteredOrg = [...filteredOrg, ...this.getDomainOrgs(org)];
    });

    return filteredOrg;
  }

  withAllOption(orgList: ReportOrgOption[]) {
    return [
      { orgId: 'All', name: 'All', role: -1 },
      ...(orgList || [])
    ];
  }

  onSelectMMSP(orgId: string) {
    this.selectedMmsp = orgId;
    this.selectedMsp = 'All';
    this.selectedOrg = 'All';
    this.mspSearchText = '';
    this.orgSearchText = '';
    this.setOrgList([]);

    if (orgId === 'All') {
      this.setMspList(this.withAllOption(this.allOrgList.filter(org => org.role === 2)));
    } else {
      this.setMspList(this.withAllOption(this.allOrgList.filter(org => org.parentOrg === orgId && org.role === 2)));
    }
    this.clearGeneratedTable();
  }

  onSelectMSP(orgId: string) {
    this.selectedMsp = orgId;
    this.selectedOrg = 'All';
    this.orgSearchText = '';

    if (orgId === 'All') {
      this.setOrgList([]);
    } else {
      this.setOrgList(this.withAllOption(this.allOrgList.filter(org => org.parentOrg === orgId && org.role === 3)));
    }
    this.clearGeneratedTable();
  }

  onSelectOrg(orgId: string) {
    this.selectedOrg = orgId;
    this.clearGeneratedTable();
  }

  isDescendantOf(org: ReportOrgOption, parentId: string) {
    let currentParent = org.parentOrg;
    while (currentParent) {
      if (currentParent === parentId) {
        return true;
      }
      const parent = this.allOrgList.find(item => item.orgId === currentParent);
      currentParent = parent ? parent.parentOrg : null;
    }
    return false;
  }

  getSelectedReportOrgId() {
    if (this.selectedOrg && this.selectedOrg !== 'All') {
      return this.selectedOrg;
    }

    if (this.selectedMsp && this.selectedMsp !== 'All') {
      return this.selectedMsp;
    }
    if (this.selectedMmsp && this.selectedMmsp !== 'All') { return this.selectedMmsp; }

    return this.orgId;
  }

  getOrgRoleLabel(role: number) {
    return role === 0 ? 'Root' : role === 1 ? 'Master MSP' : role === 2 ? 'MSP' : role === 3 ? 'Organization' : '';
  }

  setMmspList(list: ReportOrgOption[]) {
    this.mmspList = list || [];
    this.filterMmspOptions(this.mmspSearchText);
  }

  setMspList(list: ReportOrgOption[]) {
    this.mspList = list || [];
    this.filterMspOptions(this.mspSearchText);
  }

  setOrgList(list: ReportOrgOption[]) {
    this.orgList = list || [];
    this.filterOrgOptions(this.orgSearchText);
  }

  filterMmspOptions(searchText = '') {
    this.filteredMmspList = this.filterOrgOptionsByText(this.mmspList, searchText);
  }

  filterMspOptions(searchText = '') {
    this.filteredMspList = this.filterOrgOptionsByText(this.mspList, searchText);
  }

  filterOrgOptions(searchText = '') {
    this.filteredOrgList = this.filterOrgOptionsByText(this.orgList, searchText);
  }

  filterOrgOptionsByText(list: ReportOrgOption[], searchText = '') {
    const term = String(searchText || '').trim().toLowerCase();
    return (list || []).filter(org => {
      return org.orgId === 'All' || !term || (org.name || '').toLowerCase().indexOf(term) > -1;
    });
  }

  loadData() {
    const reportOrgId = this.getSelectedReportOrgId();
    if (!reportOrgId) return;

    if (this.loadDataSubscription) {
      this.loadDataSubscription.unsubscribe();
    }

    this.loading = true;
    const orgRequest = { id: reportOrgId };
    const deviceRequest = {
      params: {
        id: reportOrgId
      }
    };

    this.loadDataSubscription = combineLatest([
      this.userService.getOrganization(orgRequest),
      this.apService.getListing(deviceRequest)
    ]).subscribe(results => {
      this.loading = false;
      this.org = results[0] && results[0].data ? results[0].data[0] : null;
      this.deviceArray = results[1] && results[1].data ? results[1].data : [];
      this.deviceArray.forEach(device => {
        device.upTime = this.uptimeToStr(device.statistics ? device.statistics.upTime : device.upTime);
        device.status = this.getStatus(device.lastSeen, device['track']);
      });
      this.applyDeviceOrganizationLabels();
      this.filteredDeviceArray = [...this.deviceArray];
      this.setTopNavMenu();
    }, () => {
      this.loading = false;
      this.deviceArray = [];
      this.filteredDeviceArray = [];
      this.setTopNavMenu();
    });
  }

  clearGeneratedTable() {
    if (this.generationSubscription) { this.generationSubscription.unsubscribe(); }
    this.generateLoading = false;
    this.generatedRows = [];
    this.generatedColumns = [];
    this.generatedColumnIds = [];
    this.totalDeviceCount = 0;
    this.canExportCsv = false;
    this.generateResponse = null;
    this.generateError = '';
    this.sampleRequest = null;
    this.tableGenerated = false;
  }

  setTopNavMenu() {
    this.topnavbarService.set([
      {
        route: '/layout/report/overview',
        name: 'Report',
        type: 'link'
      },
      {
        route: '',
        name: 'Device List',
        type: 'text'
      }
    ]);
  }

  private setDefaultSelectedColumns() {
    this.selectedColumns = this.defaultSelectedColumnIds
      .map(columnId => this.availableColumns.find(column => column.id === columnId))
      .filter(column => !!column);
  }

  private applyDeviceOrganizationLabels() {
    if (!this.deviceArray || !this.deviceArray.length || !this.allOrgList || !this.allOrgList.length) {
      return;
    }

    this.deviceArray.forEach(device => {
      const orgId = this.userService.normalizeOrganizationId(device.orgId);
      const org = this.allOrgList.find(item => item.orgId === orgId);
      if (!org) return;

      device.domain = org.name;
      device['organization'] = org.name;
      const msp = this.findParentByRole(org, 2);
      device['msp'] = msp ? msp.name : '';
    });
  }

  private findParentByRole(org: ReportOrgOption, role: number) {
    let parentId = org.parentOrg;
    while (parentId) {
      const parent = this.allOrgList.find(item => item.orgId === parentId);
      if (!parent) {
        return null;
      }
      if (parent.role === role) {
        return parent;
      }
      parentId = parent.parentOrg;
    }
    return null;
  }

  isColumnSelected(column: DeviceReportColumn) {
    return this.selectedColumns.some(selectedColumn => selectedColumn.id === column.id);
  }

  getFilteredAvailableColumns() {
    return this.filterColumns(this.availableColumns, this.availableColumnSearch);
  }

  getFilteredSelectedColumns() {
    return this.filterColumns(this.selectedColumns, this.selectedColumnSearch);
  }

  clearAvailableColumnSearch() {
    this.availableColumnSearch = '';
  }

  clearSelectedColumnSearch() {
    this.selectedColumnSearch = '';
  }

  private filterColumns(columns: DeviceReportColumn[], searchText: string) {
    const search = String(searchText || '').trim().toLowerCase();
    if (!search) {
      return columns;
    }

    return columns.filter(column =>
      column.label.toLowerCase().indexOf(search) > -1 ||
      column.path.toLowerCase().indexOf(search) > -1
    );
  }

  addColumn(column: DeviceReportColumn) {
    if (this.isColumnSelected(column)) return;
    this.selectedColumns = [...this.selectedColumns, column];
  }

  removeColumn(column: DeviceReportColumn) {
    this.selectedColumns = this.selectedColumns.filter(selectedColumn => selectedColumn.id !== column.id);
  }

  moveColumn(column: DeviceReportColumn, direction: number) {
    const index = this.selectedColumns.findIndex(selectedColumn => selectedColumn.id === column.id);
    const nextIndex = index + direction;
    if (index < 0 || nextIndex < 0 || nextIndex >= this.selectedColumns.length) return;

    const columns = [...this.selectedColumns];
    columns[index] = this.selectedColumns[nextIndex];
    columns[nextIndex] = column;
    this.selectedColumns = columns;
  }

  generatePreview() {
    this.loadRequestedColumns(false, 5);
  }

  generateRequest() {
    this.loadRequestedColumns(true);
  }

  loadRequestedColumns(tableGenerated: boolean, limit?: number) {
    this.filterError = this.validateCustomFilters();
    if (this.filterError) { return; }
    this.clearGeneratedTable();
    this.sampleRequest = this.buildReportRequest(limit);
    this.generateLoading = true;
    this.generateError = '';
    this.generateResponse = null;

    const columns = this.getRequestColumns().map(column => ({ ...column }));
    this.generationSubscription = this.apService.generateRequestedColumns(this.sampleRequest).subscribe(response => {
      this.generateLoading = false;
      if (this.sampleRequest.filters && response.customFiltersApplied !== true) {
        this.generateError = 'The Devices API must be updated to support custom filters. No unfiltered report was generated.';
        return;
      }
      if (response.registrationApplied !== this.sampleRequest.registration) {
        this.generateError = 'The Devices API must be updated to include the selected device status. No incomplete report was generated.';
        return;
      }
      this.generateResponse = response;
      this.generatedColumns = columns;
      this.generatedColumnIds = this.generatedColumns.map(column => column.id);
      const rows = this.extractGeneratedRows(response);
      this.generatedRows = limit ? rows.slice(0, limit) : rows;
      this.totalDeviceCount = this.extractGeneratedTotal(response, rows.length);
      this.tableGenerated = tableGenerated;
      this.canExportCsv = tableGenerated;
    }, error => {
      this.generateLoading = false;
      this.generateError = error?.error?.message || error?.error?.error || 'Failed to generate requested columns.';
    });
  }

  buildReportRequest(limit?: number): DeviceListReportRequest {
    const requestColumns = this.getRequestColumns();
    const request: DeviceListReportRequest = {
      orgId: this.getSelectedReportOrgId(),
      registration: this.registration,
      columns: requestColumns.map(column => ({
        id: column.id,
        label: column.label,
        path: column.path
      }))
    };

    if (limit) {
      request.limit = limit;
    }
    if (this.importedDevices.length) {
      request.devices = this.importedDevices.map(device => ({ ...device }));
    }
    if (this.customFilters.length) {
      request.filters = { mode: this.filterMode, rules: this.customFilters.map(rule => ({ ...rule, path: rule.path.trim() })) };
    }

    return request;
  }

  getFilterFields() {
    // These values are computed after the database query, rather than stored fields.
    const derived = ['msp', 'organization', 'status', 'terminal_url'];
    return this.filterColumns(this.availableColumns.filter(column => !derived.includes(column.path)), this.filterFieldSearch);
  }

  addFilter(path: string) {
    if (this.customFilters.length >= 20) { this.filterError = 'Use up to 20 filter rules.'; return; }
    if (!this.validFilterPath(path)) { this.filterError = 'Enter a field path such as statistics.firmware.currentVersion.'; return; }
    this.customFilters.push({ path: path.trim(), operator: 'eq', value: '' });
    this.customFilterPath = '';
    this.filtersChanged();
  }

  filtersChanged() {
    this.filterError = '';
    this.clearGeneratedTable();
  }

  removeFilter(index: number) {
    this.customFilters.splice(index, 1);
    this.filtersChanged();
  }

  clearFilters() {
    this.customFilters = [];
    this.filtersChanged();
  }

  moveFilter(index: number, direction: number) {
    const target = index + direction;
    if (target < 0 || target >= this.customFilters.length) { return; }
    const rule = this.customFilters.splice(index, 1)[0];
    this.customFilters.splice(target, 0, rule);
  }

  startFilterDrag(event: DragEvent, path: string, index: number = null) {
    this.draggedFilterPath = path;
    this.draggedFilterIndex = index;
    event.dataTransfer.setData('text/plain', path);
    event.dataTransfer.effectAllowed = index == null ? 'copy' : 'move';
  }

  endFilterDrag() {
    this.draggedFilterPath = '';
    this.draggedFilterIndex = null;
  }

  dropFilter(event: DragEvent, index: number = this.customFilters.length) {
    event.preventDefault();
    event.stopPropagation();
    if (this.draggedFilterIndex != null) {
      const rule = this.customFilters.splice(this.draggedFilterIndex, 1)[0];
      this.customFilters.splice(Math.min(index, this.customFilters.length), 0, rule);
    } else if (this.draggedFilterPath) {
      this.addFilter(this.draggedFilterPath);
    }
    this.endFilterDrag();
  }

  private validFilterPath(path: string) {
    return typeof path === 'string' && /^[A-Za-z0-9_]+(?:\.[A-Za-z0-9_]+)*$/.test(path.trim())
      && !['msp', 'organization', 'status', 'terminal_url'].includes(path.trim())
      && !path.split('.').some(part => ['__proto__', 'prototype', 'constructor'].includes(part));
  }

  validateCustomFilters(): string {
    return this.customFilters.some(rule => !this.validFilterPath(rule.path) || (!['isNull', 'isEmpty'].includes(rule.operator) && String(rule.value).trim() === ''))
      ? 'Each filter needs a valid field path and a value.' : '';
  }

  onDeviceCsvSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input && input.files && input.files.length ? input.files[0] : null;
    if (!file) return;

    this.csvImportError = '';
    this.csvImportFileName = file.name;
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const rows = this.parseCsvRows(String(reader.result || ''));
        const devices = this.extractImportedDevices(rows);
        if (!devices.length) {
          throw new Error('No MAC addresses or device names were found in the CSV.');
        }
        this.importedDevices = devices;
        this.clearGeneratedTable();
        this.generatePreview();
      } catch (error) {
        this.importedDevices = [];
        this.clearGeneratedTable();
        this.csvImportError = error && error.message ? error.message : 'Unable to read the CSV file.';
      }
      input.value = '';
    };
    reader.onerror = () => {
      this.importedDevices = [];
      this.csvImportError = 'Unable to read the CSV file.';
      input.value = '';
    };
    reader.readAsText(file);
  }

  clearImportedDevices() {
    this.importedDevices = [];
    this.csvImportError = '';
    this.csvImportFileName = '';
    this.clearGeneratedTable();
  }

  parseCsvRows(text: string): string[][] {
    const rows: string[][] = [];
    let row: string[] = [];
    let value = '';
    let quoted = false;
    const source = String(text || '').replace(/^\uFEFF/, '');

    for (let index = 0; index < source.length; index++) {
      const character = source[index];
      if (character === '"') {
        if (quoted && source[index + 1] === '"') {
          value += '"';
          index++;
        } else {
          quoted = !quoted;
        }
      } else if (character === ',' && !quoted) {
        row.push(value.trim());
        value = '';
      } else if ((character === '\n' || character === '\r') && !quoted) {
        if (character === '\r' && source[index + 1] === '\n') index++;
        row.push(value.trim());
        if (row.some(cell => cell.length)) rows.push(row);
        row = [];
        value = '';
      } else {
        value += character;
      }
    }
    row.push(value.trim());
    if (row.some(cell => cell.length)) rows.push(row);
    if (quoted) throw new Error('The CSV contains an unterminated quoted value.');
    return rows;
  }

  extractImportedDevices(rows: string[][]): Array<{ mac?: string, name?: string }> {
    if (!rows.length) return [];
    const normalizedHeaders = rows[0].map(value => String(value || '').trim().toLowerCase().replace(/[^a-z0-9]/g, ''));
    const macHeaders = ['mac', 'macaddress', 'devicemac'];
    const nameHeaders = ['name', 'devicename', 'hostname', 'host'];
    const macIndex = normalizedHeaders.findIndex(header => macHeaders.indexOf(header) > -1);
    const nameIndex = normalizedHeaders.findIndex(header => nameHeaders.indexOf(header) > -1);
    const hasHeader = macIndex > -1 || nameIndex > -1;
    const devices = (hasHeader ? rows.slice(1) : rows).map(row => {
      if (hasHeader) {
        return {
          mac: macIndex > -1 ? this.normalizeImportedMac(row[macIndex]) : '',
          name: nameIndex > -1 ? String(row[nameIndex] || '').trim() : ''
        };
      }
      const macCellIndex = row.findIndex(cell => !!this.normalizeImportedMac(cell));
      const nameCell = row.find((cell, index) => index !== macCellIndex && String(cell || '').trim());
      return {
        mac: macCellIndex > -1 ? this.normalizeImportedMac(row[macCellIndex]) : '',
        name: String(nameCell || '').trim()
      };
    }).filter(device => device.mac || device.name);

    const seen = new Set<string>();
    return devices.filter(device => {
      const key = `${device.mac || ''}|${String(device.name || '').toLowerCase()}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  normalizeImportedMac(value: any) {
    const compact = String(value || '').toLowerCase().replace(/[^a-f0-9]/g, '');
    return compact.length === 12 ? compact.match(/.{2}/g).join(':') : '';
  }

  getRequestColumns() {
    if (this.selectedColumns.length) {
      return this.selectedColumns;
    }

    return this.defaultSelectedColumnIds
      .map(columnId => this.availableColumns.find(column => column.id === columnId))
      .filter(column => !!column);
  }

  extractGeneratedRows(response: any) {
    if (Array.isArray(response)) {
      return response;
    }

    if (response && Array.isArray(response.data)) {
      return response.data;
    }

    if (response && response.data && Array.isArray(response.data.rows)) {
      return response.data.rows;
    }

    if (response && Array.isArray(response.rows)) {
      return response.rows;
    }

    if (response && response.data && Array.isArray(response.data.devices)) {
      return response.data.devices;
    }

    return [];
  }

  extractGeneratedTotal(response: any, fallback: number) {
    if (response && typeof response.count === 'number') {
      return response.count;
    }

    if (response && typeof response.total === 'number') {
      return response.total;
    }

    if (response && typeof response.totalCount === 'number') {
      return response.totalCount;
    }

    if (response && response.data && typeof response.data.count === 'number') {
      return response.data.count;
    }

    if (response && response.data && typeof response.data.total === 'number') {
      return response.data.total;
    }

    if (response && response.data && typeof response.data.totalCount === 'number') {
      return response.data.totalCount;
    }

    return fallback || 0;
  }

  getDisplayedDeviceCount() {
    return this.getTableRows().length;
  }

  getTotalDeviceCount() {
    return this.totalDeviceCount || this.getDisplayedDeviceCount();
  }

  getPreviewRows() {
    return (this.filteredDeviceArray || []).slice(0, 10);
  }

  getTableRows() {
    return this.generatedRows || [];
  }

  getTableTitle() {
    return this.tableGenerated ? 'Table Generated' : 'Table Preview';
  }

  exportGeneratedTableCsv() {
    if (!this.generatedColumns.length || !this.getTableRows().length) return;

    const rows = [
      this.generatedColumns.map(column => this.escapeCsvValue(column.label)).join(','),
      ...this.getTableRows().map(row => {
        return this.generatedColumns
          .map(column => this.escapeCsvValue(this.getColumnValue(row, column)))
          .join(',');
      })
    ];

    const blob = new Blob([rows.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `device-list-report-${this.getSelectedReportOrgId() || 'org'}.csv`;
    link.click();
    window.URL.revokeObjectURL(url);
  }

  escapeCsvValue(value: any) {
    const text = String(value === undefined || value === null ? '' : value);
    return `"${text.replace(/"/g, '""')}"`;
  }

  getColumnValue(device: any, column: DeviceReportColumn) {
    let value = this.getValueByPath(device, column.path);
    if ((value === undefined || value === null || value === '') && device && device[column.id] !== undefined) {
      value = device[column.id];
    }

    if (column.id === 'base_license') {
      return this.getLicenseLabel(value);
    }

    if (column.id === 'status') {
      return this.getStatusLabel(value);
    }

    if (value === undefined || value === null || value === '') {
      return '-';
    }

    if (value instanceof Date) {
      return value.toLocaleString();
    }

    if (Array.isArray(value)) {
      return value.map(item => this.formatValue(item)).join(', ');
    }

    return this.formatValue(value);
  }

  isTerminalJumpColumn(column: DeviceReportColumn) {
    return column && (column.id === 'terminal_jump' || column.path === 'terminal_url');
  }

  getTerminalJumpUrl(device: any) {
    return device && device.terminal_url ? String(device.terminal_url) : '';
  }

  trackTerminalJump(device: any) {
    if (device && device.mac) {
      this.apService.createDeviceBrowseHistory(device.mac, 'terminal').subscribe();
    }
  }

  getLicenseLabel(license) {
    if (!license) {
      return '-';
    }

    const licenseOption = BaseLicensesTypes.find(item => item.value === license);
    return licenseOption ? licenseOption.name : license;
  }

  getStatusLabel(status) {
    if (status === undefined || status === null || status === '') {
      return '-';
    }

    if (status === 1 || status === true || String(status).toLowerCase() === 'online') {
      return 'on';
    }

    if (status === 2 || String(status).toLowerCase() === 'warning') {
      return 'warn';
    }

    if (status === 0 || status === false || String(status).toLowerCase() === 'offline') {
      return 'off';
    }

    const statusText = String(status).toLowerCase();
    if (statusText === 'on' || statusText === 'off' || statusText === 'warn') {
      return statusText;
    }

    return statusText;
  }

  private getValueByPath(data: any, path: string) {
    return path.split('.').reduce((value, key) => {
      if (value === undefined || value === null) return undefined;
      return value[key];
    }, data);
  }

  private formatValue(value: any) {
    if (value === undefined || value === null || value === '') {
      return '-';
    }

    if (typeof value === 'object') {
      if (value._id) return value._id;
      if (value.$oid) return value.$oid;
      return JSON.stringify(value);
    }

    return String(value);
  }

  getStatus(date, track) {
    if (track && track.length > 0) {
      if (track[0].lastDeviceState === 1) {
        return 'on';
      } else if (track[0].lastDeviceState === 2) {
        return 'warn';
      }
      return 'off';
    }

    if (!date) {
      return 'off';
    }

    const time = new Date(date);
    const cdate = new Date();
    const datedifferance = cdate.getTime() - time.getTime();
    if (datedifferance > 600e3) {
      return 'off';
    } else if (datedifferance < 600e3 && datedifferance > 300e3) {
      return 'warn';
    }
    return 'on';
  }

  uptimeToStr(input) {
    if (input == null) {
      return '-';
    }
    let day, hour, minutes, seconds, n;
    n = Math.floor(Number(input));
    day = Math.floor(n / (24 * 3600));
    n = Math.floor(n % (24 * 3600));
    hour = Math.floor(n / 3600);
    n = Math.floor(n % 3600);
    minutes = Math.floor(n / 60);
    n = Math.floor(n % 60);
    seconds = n;
    let str = '';
    str = str + (day ? day + 'd ' : '');
    str = str + (hour ? hour + 'h ' : '');
    str = str + (minutes ? minutes + 'm ' : '');
    str = str + (seconds ? seconds + 's' : '');
    return str;
  }

  ngOnDestroy(): void {
    if (this.generationSubscription) { this.generationSubscription.unsubscribe(); }
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
    if (this.loadDataSubscription) {
      this.loadDataSubscription.unsubscribe();
    }
  }
}
